import { describe, expect,it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import { ATTACHMENT_FIELDS,COMPANY_FIELDS, SOLD_TO_ADDRESS_FIELDS } from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages from '..';

// Type definitions for improved safety
interface Field {
  key: string;
  required?: boolean;
  conditionalCountryArray?: string[];
}

interface Card {
  key: string;
  fields?: Field[];
}

interface Page {
  route: string;
  cards?: Card[];
  accordions?: {
    title: string;
    cards: Card[];
  }[];
}

describe('Company Page Template', () => {
  it('exports pages array with two pages', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(2);
  });

  const companyPage = pages.find((p: Page) => p.route === PAGE_ROUTES.company) as Page;

  it('has correct route and cards', () => {
    expect(companyPage).toBeDefined();
    expect(companyPage.route).toBe(PAGE_ROUTES.company);
    expect(companyPage.cards?.map(c => c.key)).toEqual([
      CARD_CATEGORIES.company,
      CARD_CATEGORIES.soldTo,
      CARD_CATEGORIES.additionalAttachmentCard,
      CARD_CATEGORIES.privacyPolicy
    ]);
  });

  it('company card has required tradeDbaName field', () => {
    const companyCard = companyPage.cards?.find(c => c.key === CARD_CATEGORIES.company) as Card;
    const tradeField = companyCard.fields?.find(f => f.key === COMPANY_FIELDS.tradeDbaName);
    expect(tradeField?.required).toBe(true);
  });

  it('soldTo card has conditionalCountryArray for taxNumber1', () => {
    const soldToCard = companyPage.cards?.find(c => c.key === CARD_CATEGORIES.soldTo) as Card;
    const taxField = soldToCard.fields?.find(f => f.key === SOLD_TO_ADDRESS_FIELDS.taxNumber1);
    expect(Array.isArray(taxField?.conditionalCountryArray)).toBe(true);
    expect(taxField?.conditionalCountryArray).toContain('TR'); // example
  });

  it('additionalAttachmentCard has correct field', () => {
    const attachmentCard = companyPage.cards?.find(c => c.key === CARD_CATEGORIES.additionalAttachmentCard) as Card;
    expect(attachmentCard.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
  });

  it('privacyPolicy card has no fields', () => {
    const privacyCard = companyPage.cards?.find(c => c.key === CARD_CATEGORIES.privacyPolicy) as Card;
    expect(privacyCard.fields).toBeUndefined();
  });
});

describe('Review Page Template', () => {
  const reviewPage = pages.find((p: Page) => p.route === PAGE_ROUTES.review) as Page;
  const companyPage = pages.find((p: Page) => p.route === PAGE_ROUTES.company) as Page;

  it('exists and has correct accordion', () => {
    expect(reviewPage).toBeDefined();
    expect(reviewPage.accordions).toHaveLength(1);
    expect(reviewPage.accordions?.[0].title).toBe('tabTitles.company');
    expect(reviewPage.accordions?.[0].cards).toEqual(companyPage.cards);
  });
});